/**
 * Anjanikaa ambient background — round 2 visibility fix.
 *
 * The original build rendered the watermark words in one fixed,
 * full-viewport layer at z-index: -1, sitting behind the ENTIRE page.
 * Since every one of Anjanikaa's locked color schemes paints its own
 * opaque section background, that layer was invisible except in page
 * gutters. This script instead inserts a handful of words as direct
 * children of a handful of the page's own section wrappers (scoped to
 * <main> only), each scoped with isolation: isolate (see
 * component-ambient-background.css) so a word paints behind that one
 * section's real content but on top of that section's own background.
 *
 * Kept deliberately restrained per the brand's "effects support the
 * product, never compete with it" standard: a fixed cap on how many
 * sections get a word, one word per chosen section, low opacity, no
 * layout impact (isolation/relative positioning do not reflow anything).
 *
 * Round 2: the word pool (snippets/ambient-background.liquid) now holds
 * 10 curated words but only MAX_WORDS show per page load. Rather than
 * always showing words[0..4] in the same order on every page, the pool is
 * shuffled first so a different subset surfaces on each visit/page --
 * the full list gets seen over time instead of half of it going unused.
 */
(function () {
  var MAX_WORDS = 5;

  function shuffle(list) {
    var arr = list.slice();
    for (var i = arr.length - 1; i > 0; i--) {
      var j = Math.floor(Math.random() * (i + 1));
      var tmp = arr[i];
      arr[i] = arr[j];
      arr[j] = tmp;
    }
    return arr;
  }

  function ready(fn) {
    if (document.readyState !== 'loading') {
      fn();
    } else {
      document.addEventListener('DOMContentLoaded', fn);
    }
  }

  ready(function () {
    var words = window.anjanikaaAmbientWords;
    if (!words || !words.length) return;
    words = shuffle(words);

    var main = document.getElementById('MainContent');
    if (!main) return;

    var hosts = Array.prototype.slice.call(
      main.querySelectorAll('.shopify-section > [class*="color-scheme-"]')
    );
    if (!hosts.length) return;

    var reducedMotion =
      window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    // Spread chosen hosts evenly across the page rather than clustering on
    // the first few sections, then cap at MAX_WORDS.
    var step = Math.max(1, Math.floor(hosts.length / MAX_WORDS));
    var chosen = [];
    for (var i = 0; i < hosts.length && chosen.length < MAX_WORDS; i += step) {
      chosen.push(hosts[i]);
    }

    var placements = [
      { top: '8%', left: '5%' },
      { top: '14%', right: '6%' },
      { top: '46%', left: '9%' },
      { top: '52%', right: '8%' },
      { top: '76%', left: '30%' },
    ];

    chosen.forEach(function (host, index) {
      host.classList.add('anjanikaa-ambient-host');

      var word = words[index % words.length];
      var span = document.createElement('span');
      span.className = 'anjanikaa-ambient-word';
      span.setAttribute('aria-hidden', 'true');
      span.textContent = word;

      var placement = placements[index % placements.length];
      for (var key in placement) {
        if (Object.prototype.hasOwnProperty.call(placement, key)) {
          span.style[key] = placement[key];
        }
      }

      span.style.fontSize = 3.2 + (index % 3) * 1.1 + 'rem';

      if (!reducedMotion) {
        span.style.animationDuration = 24 + index * 3 + 's';
        span.style.animationDelay = '-' + index * 4 + 's';
      }

      host.insertBefore(span, host.firstChild);
    });
  });
})();
